export const sysDeptUserPageSizeOptions = [10, 20, 50, 100];

export const sysDeptUserDefaultListParams = {
  page: 1,
  pageSize: 20,
  sortField: "update_time",
  sortDirection: "desc" as const,
};

export const sysDeptStatusOptions = [
  { label: "启用", value: 1 },
  { label: "停用", value: 0 },
];
